// extracted by mini-css-extract-plugin
export default {"activityIndicator":"styles__activityIndicator___Zifce"};